//---------------------------------------------------------------------------
// プラムページ　リスト
//---------------------------------------------------------------------------
var AdvanceCheckList = Backbone.View.extend({
	events:{
		"click #set_program_btn":"onClickProgram",

		"click #set_program_submit" : "onClickSubmit",

		"change #bulkCheck" : "onCheckBulkInput",
	},



	initialize:function(){

	},


/*=============================
=            Event            =
=============================*/
	onClickProgram:function(){
		this.$("#program_set_modal").modal("show");

		return false;
	},

	onClickSubmit:function(){
		this.$("#program_set_form").submit();
		return false;
	},

	onCheckBulkInput:function(){
		var checked = $('#bulkCheck').prop('checked');
		if(checked){
			$('.ios-switch').each(function(){
				$(this).addClass('on');
			})
		}else{
			$('.ios-switch').each(function(){
				$(this).removeClass('on');
			})
		}
		$('.action_checkbox').each(function(){
			$(this).prop('checked',checked);
		})
	},

	

/*=====  End of Event  ======*/



});